import $ from "jquery"
import "select2/dist/js/select2.full"

let select2Factory = null

try {
  // Keep a direct factory reference in case the side-effect import did not bind to our jQuery instance.
  // eslint-disable-next-line global-require
  select2Factory = require("select2/dist/js/select2.full")
} catch (_error) {
  select2Factory = null
}

if (typeof $.fn?.select2 !== "function" && typeof select2Factory === "function") {
  select2Factory(window, $)
}

if (window.$ && typeof window.$.fn?.select2 !== "function" && typeof $.fn?.select2 === "function") {
  window.$.fn.select2 = $.fn.select2
}

if (window.jQuery && typeof window.jQuery.fn?.select2 !== "function" && typeof $.fn?.select2 === "function") {
  window.jQuery.fn.select2 = $.fn.select2
}

window.Select2 = $.fn?.select2

if (typeof $.fn?.select2 !== "function") {
  console.error("[select2] failed to initialize on window.jQuery")
}
